import { FC, PointerEvent } from 'react'

import { ModalProps } from '@mantine/core'
import { STAKE_URL } from 'config/index'

import { ButtonGradient } from 'components/ButtonGradient'
import CustomModal from 'components/CustomModal'

import s from './s.module.scss'

import Reject from './Reject'
import Success from './Success'

type Props = {
  error: boolean
  isReceivedClaim: boolean
} & ModalProps

const FinalClaimModal: FC<Props> = ({ error, isReceivedClaim, ...props }) => {
  const onStake = (event: PointerEvent<HTMLButtonElement>) => {
    event.preventDefault()
    window.open(STAKE_URL)
  }

  const ButtonsBlock = (
    <div className={s.buttons}>
      <ButtonGradient className={s.buttonStake} onClick={props.onClose}>
        Close
      </ButtonGradient>
      <ButtonGradient className={s.buttonClose} disabled onClick={onStake}>
        Staking coming soon...
      </ButtonGradient>
    </div>
  )

  return (
    <CustomModal
      {...props}
      centered
      classNames={{
        body: s.body,
        content: s.inner,
      }}
    >
      {isReceivedClaim && <Success>{ButtonsBlock}</Success>}
      {!!error && <Reject>{ButtonsBlock}</Reject>}
    </CustomModal>
  )
}

export default FinalClaimModal
